import { studyQueryKeys } from '@/config/queryKeys';
import { fetchStudy } from '@/services/studies';
import { useAppStore } from '@/stores/app';
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/studies/$studyId')({
  loader: ({ context: { queryClient }, params: { studyId } }) => {
    const selectedOrg = useAppStore.getState()?.selectedOrganization;
    if (!selectedOrg?.id) throw redirect({ to: '/organizations' });
    return queryClient.ensureQueryData({
      queryKey: studyQueryKeys.detail(selectedOrg.id, studyId),
      queryFn: () => fetchStudy(selectedOrg.id, studyId),
    });
  },
});
